import type { RouteData } from 'src/shared/app/base/route/type/routeTypes';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';

export default function useRoutes(...args: Array<RouteData>): Array<string> {
  return args.map((route) => getRoutePath(route));
}
